var InterpolationType = {
  NEAREST: 0,
  LINEAR: 1,
  FAST_LINEAR: 2
};
var OpacityMode = {
  FRACTIONAL: 0,
  PROPORTIONAL: 1
};
var Constants = {
  InterpolationType: InterpolationType,
  OpacityMode: OpacityMode
};

export { InterpolationType, OpacityMode, Constants as default };
